import React from "react"
import PropTypes from "prop-types"
import { Card, CardBody, CardTitle, Media, Alert } from "reactstrap"
import { map } from "lodash"
import planets from "assets/images/planets"
import { isEmpty } from "lodash"

const BirthReport = ({ reportJson }) => {
  let reportObject = JSON.parse(reportJson);
  console.log(reportObject)
  let userRoles = {
    user: false,
    groupUser: false,
    productAdmin: false,
  }
  if (sessionStorage.getItem("userRoles")) {
    let savedUserRoles = JSON.parse(sessionStorage.getItem("userRoles"));
    if (savedUserRoles !== undefined) {
      userRoles = savedUserRoles;
    }
  }
  return (
    <Card>
      <CardBody>
        <CardTitle className="mb-4">
          <Alert color="info" className="mb-0" role="alert">
            Report Summary
          </Alert>
        </CardTitle>

        {userRoles.productAdmin && (
          <div color="info">
            <ul className="verti-timeline list-unstyled">
              {map(reportObject, (report, k) => (
                <li className="event-list" key={k}>
                  <div className="event-timeline-dot">
                    <i className="bx bx-right-arrow-circle"></i>
                  </div>

                  <Media>
                    <div className="me-3">
                      {/* <i className={"bx bx-" + report.planet.toLocaleLowerCase() + " h2 text-primary"}></i> */}
                      <img src={planets[report.planet.toLocaleLowerCase()]} alt="" height="25" alt={report.planet.toLocaleLowerCase()} />
                    </div>
                    <Media body>
                      <div>
                        <h5>
                          {report.descriptionTitle}
                        </h5>
                        {!isEmpty(report.description) && (
                          <p className="text-muted">
                            {report.description}
                          </p>
                        )}
                      </div>
                    </Media>
                  </Media>
                </li>
              ))}
            </ul>
          </div>
        )}

        {userRoles.user && (
          <div color="info">
            <ul className="verti-timeline list-unstyled">
              {map(reportObject, (report, k) => (
                <div>
                  {!isEmpty(report.description) && (
                    <li className="event-list" key={k}>
                      <div className="event-timeline-dot">
                        <i className="bx bx-right-arrow-circle"></i>
                      </div>
                      <Media body>
                        <div>
                          <p className="text-muted">
                            {report.description}
                          </p>
                        </div>
                      </Media>
                    </li>
                  )}
                </div>
              ))}
            </ul>
          </div>
        )}

      </CardBody>
    </Card >
  )
}

BirthReport.propTypes = {
  options: PropTypes.object,
  series: PropTypes.array,
}

export default BirthReport
